export const removeWrapedDiv = (htmlStr: string) => {
  return htmlStr.replace(/^<div[^>]*>|<\/div>$/g, "");
};
